export default "__VITE_ASSET__48076403__"